export default __webpack_public_path__ + "static/media/red_export_icon.88e3c0b2.svg";